import EventDetailModal from './EventDetailModal';

export default EventDetailModal;
